import {alpha, CardActions, CardContent, CardMedia, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card/Card";
import {IWish} from "../../../../store/wish/Helper";
import * as React from "react";
import {FC, useState} from "react";
import {useTranslation} from "react-i18next";
import {RoutePaths} from "../../../../util/constants";
import ReactGA from "react-ga4";
import CompanyLabel from "../../../shared/company-label/CompanyLabel";
import {useTheme} from "@mui/material/styles";
import Confetti from "react-confetti";
import {Link as RouterLink} from "react-router-dom";
import GiftBow from "../../../shared/gift-bow/GiftBow";
import ViewWinnersDialog from "../../../dialogs/view-winners-dialog/ViewWinnersDialog";
import {useIsUserWinner} from "../../../../util/hooks/useWinnerHelpers";
import WinnersBadge from "../../../shared/winners-badge/WinnersBadge";
import Box from "@mui/material/Box";

interface IProps {
    wish: IWish
}

const PastWishesItem: FC<IProps> = (props) => {
    const {t, i18n} = useTranslation()
    const theme = useTheme()
    const [openWinnersDialog, setOpenWinnersDialog] = useState(false)

    const handleSeeWishDetailsButton = (wishId: string) => {
        ReactGA.event("select_item", {items: [{item_id: wishId, item_name: 'Wish - Past Winners'}]})
    }

    const handleOpenWinnersDialog = () => {
        setOpenWinnersDialog(true)
    }

    const isJpgThumbnail = props.wish.thumbnail.toLowerCase().endsWith('.jpg') || props.wish.thumbnail.toLowerCase().endsWith('.jpeg')

    const isWinner = useIsUserWinner(props.wish.winners)

    return (
        <Card elevation={3} sx={{
            display: 'flex',
            flexDirection: 'column',
            width: {xs: '100%', sm: 265},
            backgroundColor: "transparent",
            border: `1px solid ${theme.palette.tertiary.main}`,
            my: 2,
            mx: 0.8,
            position: 'relative'
        }}>
            {isWinner && <Confetti
                gravity={0.05}
            />}
            <GiftBow showRibbon={true}/>
            <Box sx={{position: "relative", width: "100%"}}>
                <CardMedia
                    component="img"
                    sx={{
                        objectFit: isJpgThumbnail ? 'cover' : 'contain',
                        height: 'auto',
                        width: '100%',
                        aspectRatio: '16/9',
                        borderBottom: !isJpgThumbnail ? `1px solid ${alpha(theme.palette.tertiary.main, 0.22)}` : "none",
                    }}
                    image={props.wish.thumbnail}
                    alt="Wish thumbnail"
                />
                <WinnersBadge
                    count={props.wish.number_of_winners}
                    color={theme.palette.tertiary.main}
                    sx={{
                        position: "absolute",
                        left: 0,
                        bottom: "0.65em",
                        zIndex: 2,
                        maxWidth: "calc(100% - 0.8em)",
                    }}
                />
            </Box>
            <CardContent sx={{flex: 1, p: 1}}>
                <Typography textAlign='center' variant="h5" sx={{color: theme.palette.tertiary.main}} fontWeight={600}>
                    {props.wish[`name_${i18n.language}`]}
                </Typography>
                <Grid container justifyContent="center">
                    <CompanyLabel company={props.wish.company} companyUrl={props.wish.company_url}
                                  color={theme.palette.tertiary.main}/>
                </Grid>
            </CardContent>
            <CardActions sx={{flexDirection: 'column', gap: 1, p: 1, pt: 0}}>
                <Button variant="contained"
                        color="tertiary"
                        fullWidth
                        onClick={handleOpenWinnersDialog}>{t('see_winners', {count: props.wish.number_of_winners})}</Button>
                <Button variant="outlined"
                        component={RouterLink}
                        to={`${RoutePaths.WISHES}/${props.wish.id}`}
                        color="tertiary"
                        fullWidth
                        onClick={() => handleSeeWishDetailsButton(props.wish.id)}>{t('see_wish_details')}</Button>
            </CardActions>
            <ViewWinnersDialog wish={props.wish} winners={[]} open={openWinnersDialog}
                               handleDialogClose={() => setOpenWinnersDialog(false)}/>
        </Card>
    )
}

export default PastWishesItem
